<!-- eslint-disable -->
<template>
  <v-container class="w-full sm:max-w-[90vw] mx-auto px-3 sm:px-6 pb-8">
    <SnackBar ref="snackbar" />

    <!-- HEADER -->
    <div class="w-full flex justify-between align-center mb-6">
      <v-container class="onest-font pa-0">
        <h1 class="font-bold mt-2 text-3xl sm:text-5xl leading-tight">Testes de Software</h1>
        <p class="text-slate-500 mt-1 text-sm sm:text-lg">
          Gerencie e execute suas sessões de teste de validações e consulte o
          histórico.
        </p>
      </v-container>
    </div>

    <!-- MAIN TABS -->
    <v-card
      class="rounded-xl sm:rounded-2xl border border-slate-150 shadow-sm overflow-hidden bg-white"
    >
      <v-tabs
        v-model="tab"
        color="primary"
        bg-color="white"
        align-tabs="start"
        class="border-b border-slate-150 font-bold"
      >
        <v-tab
          value="active"
          class="py-3 px-3 sm:py-4 sm:px-6 text-sm sm:text-body-1 font-bold onest-font"
        >
          <v-icon start icon="mdi-play-circle-outline" class="mr-1 sm:mr-2"></v-icon>
          Validações Ativas ({{ activeCycles.length }})
        </v-tab>
        <v-tab
          value="history"
          class="py-3 px-3 sm:py-4 sm:px-6 text-sm sm:text-body-1 font-bold onest-font"
        >
          <v-icon start icon="mdi-history" class="mr-1 sm:mr-2"></v-icon>
          Histórico ({{ pastCycles.length }})
        </v-tab>
      </v-tabs>

      <v-card-text class="pa-3 pa-sm-6 bg-slate-50/30">
        <v-window v-model="tab">
          <!-- ACTIVE CYCLES TAB -->
          <v-window-item value="active">
            <div v-if="loading" class="text-center py-12">
              <v-progress-circular
                indeterminate
                color="primary"
                size="64"
                class="mb-4"
              ></v-progress-circular>
              <p class="text-slate-500 font-medium">
                Carregando sessões de validação...
              </p>
            </div>

            <div
              v-else-if="activeCycles.length === 0"
              class="text-center py-16 bg-white border border-dashed border-slate-300 rounded-2xl max-w-2xl mx-auto my-6"
            >
              <v-icon size="64" color="slate-400" class="mb-4"
                >mdi-clipboard-text-search-outline</v-icon
              >
              <h3 class="text-xl font-bold text-slate-700">
                Nenhuma validação ativa
              </h3>
              <p class="text-slate-500 mt-2">
                Você não possui ciclos de validação em andamento ou o prazo de
                execução expirou.
              </p>
            </div>

            <v-expansion-panels
              v-else
              v-model="activePanels"
              multiple
              class="gap-4"
            >
              <v-expansion-panel
                v-for="cycle in activeCycles"
                :key="cycle.id_validacao"
                class="rounded-xl border border-slate-150 overflow-hidden shadow-none mb-3"
              >
                <v-expansion-panel-title class="bg-white py-3 px-4 sm:py-4 sm:px-6">
                  <template #default="{ expanded }">
                    <div
                      class="d-flex flex-wrap align-center justify-between w-full pr-4"
                    >
                      <div class="d-flex align-center">
                        <v-icon color="primary" class="mr-2 sm:mr-3" size="24 sm:size-28"
                          >mdi-folder-open-outline</v-icon
                        >
                        <div>
                          <span
                            class="text-lg sm:text-xl font-bold text-slate-800 onest-font"
                            >{{ cycle.nome_validacao }}</span
                          >
                          <div class="text-xs sm:text-sm text-slate-400 mt-1">
                            Situação:
                            <v-chip
                              size="x-small"
                              color="teal"
                              class="font-normal ml-1"
                              variant="tonal"
                            >
                              Usuários Testando
                            </v-chip>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex align-center gap-4 mt-2 mt-sm-0">
                        <span class="text-xs sm:text-sm text-slate-500 font-medium">
                          <v-icon
                            start
                            icon="mdi-calendar-range"
                            size="14 sm:size-16"
                            class="mr-1"
                          ></v-icon>
                          Término: {{ formatDate(cycle.data_final_etapa) }}
                        </span>
                      </div>
                    </div>
                  </template>
                </v-expansion-panel-title>

                <v-expansion-panel-text
                  class="bg-slate-50/50 pa-2 pa-sm-4 border-t border-slate-150"
                >
                  <div class="space-y-6">
                    <div
                      v-for="projeto in cycle.projetos"
                      :key="projeto.id_projeto"
                      class="mb-6"
                    >
                      <!-- Projeto Title -->
                      <div class="d-flex align-center justify-between mb-2">
                        <div class="d-flex align-center">
                          <span
                            class="bg-primary/10 text-primary font-bold px-2 py-0.5 sm:px-3 sm:py-1 rounded-lg text-xs sm:text-sm mr-2 sm:mr-3"
                          >
                            {{ projeto.sigla }}
                          </span>
                          <h3 class="text-base sm:text-xl font-bold text-slate-800">
                            {{ projeto.nome }}
                          </h3>
                        </div>
                      </div>

                      <!-- List of Roteiros inside Project -->
                      <!-- Desktop View: table layout -->
                      <div class="hidden sm:block table-responsive">
                        <table
                          class="w-full border-separate border-spacing-y-2 onest-font"
                        >
                          <thead>
                            <tr class="text-slate-500 font-medium text-sm">
                              <th class="p-4 text-left">Papel</th>
                              <th class="p-4 text-left">
                                Progresso de Validação
                              </th>
                              <th class="p-4 text-left">Status</th>
                              <th class="p-4 text-center">Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="roteiro in projeto.roteiros"
                              :key="roteiro.id_roteiro"
                              class="hover:bg-blue-50/50 transition-colors bg-white shadow-sm rounded-xl"
                            >
                              <td
                                class="py-4 px-6 font-normal text-slate-700 rounded-l-xl"
                              >
                                {{ roteiro.nome_ator }}
                              </td>
                              <td
                                class="py-4 px-6 text-slate-600"
                                style="width: 40%"
                              >
                                <div class="d-flex align-center">
                                  <v-progress-linear
                                    v-model="roteiro.progressoPercent"
                                    color="primary"
                                    height="8"
                                    rounded
                                    class="mr-3 flex-grow-1"
                                    bg-color="slate-200"
                                  ></v-progress-linear>
                                  <span
                                    class="text-sm font-bold text-slate-600 whitespace-nowrap"
                                  >
                                    {{ roteiro.avaliadas }}/{{ roteiro.total }}
                                    Func.
                                  </span>
                                </div>
                              </td>
                              <td class="py-4 px-2">
                                <v-chip
                                  size="small"
                                  :color="getStatusColor(roteiro.status)"
                                  class="font-normal"
                                  variant="tonal"
                                >
                                  {{ formatStatusText(roteiro.status) }}
                                </v-chip>
                              </td>
                              <td class="py-4 px-4 text-center rounded-r-xl">
                                <v-btn
                                  color="primary"
                                  variant="outlined"
                                  size="small"
                                  class="text-center font-normal rounded-full"
                                  prepend-icon="mdi-script-text-outline"
                                  @click="
                                    irParaRoteiro(
                                      projeto.id_projeto,
                                      roteiro.id_roteiro,
                                    )
                                  "
                                >
                                  Acessar Roteiro
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <!-- Mobile View: cards list -->
                      <div class="block sm:hidden space-y-4">
                        <div
                          v-for="roteiro in projeto.roteiros"
                          :key="roteiro.id_roteiro"
                          class="bg-white border border-slate-200 rounded-xl p-4 shadow-sm"
                        >
                          <div class="flex justify-between items-start mb-3">
                            <div>
                              <div class="text-xs text-slate-400 font-bold uppercase">Papel</div>
                              <div class="text-base font-bold text-slate-800">{{ roteiro.nome_ator }}</div>
                            </div>
                            <v-chip
                              size="small"
                              :color="getStatusColor(roteiro.status)"
                              class="font-normal"
                              variant="tonal"
                            >
                              {{ formatStatusText(roteiro.status) }}
                            </v-chip>
                          </div>
                          
                          <div class="mb-4">
                            <div class="flex justify-between text-xs text-slate-500 font-medium mb-1">
                              <span>Progresso</span>
                              <span>{{ roteiro.avaliadas }}/{{ roteiro.total }} Func.</span>
                            </div>
                            <v-progress-linear
                              v-model="roteiro.progressoPercent"
                              color="primary"
                              height="6"
                              rounded
                              bg-color="slate-200"
                            ></v-progress-linear>
                          </div>

                          <v-btn
                            color="primary"
                            variant="outlined"
                            size="small"
                            class="w-full font-bold rounded-xl"
                            prepend-icon="mdi-script-text-outline"
                            @click="irParaRoteiro(projeto.id_projeto, roteiro.id_roteiro)"
                          >
                            Acessar Roteiro
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-window-item>

          <!-- HISTORY TAB -->
          <v-window-item value="history">
            <div v-if="loading" class="text-center py-12">
              <v-progress-circular
                indeterminate
                color="primary"
                size="64"
                class="mb-4"
              ></v-progress-circular>
              <p class="text-slate-500 font-medium">Carregando histórico...</p>
            </div>

            <div
              v-else-if="pastCycles.length === 0"
              class="text-center py-16 bg-white border border-dashed border-slate-300 rounded-2xl max-w-2xl mx-auto my-6"
            >
              <v-icon size="64" color="slate-400" class="mb-4"
                >mdi-history</v-icon
              >
              <h3 class="text-xl font-bold text-slate-700">
                Nenhum histórico disponível
              </h3>
              <p class="text-slate-500 mt-2">
                Nenhum ciclo de validação anterior foi encontrado.
              </p>
            </div>

            <v-expansion-panels
              v-else
              v-model="pastPanels"
              multiple
              class="gap-4"
            >
              <v-expansion-panel
                v-for="cycle in pastCycles"
                :key="cycle.id_validacao"
                class="rounded-xl border border-slate-150 overflow-hidden shadow-none mb-3"
              >
                <v-expansion-panel-title class="bg-white py-3 px-4 sm:py-4 sm:px-6">
                  <template #default="{ expanded }">
                    <div
                      class="d-flex flex-wrap align-center justify-between w-full pr-4"
                    >
                      <div class="d-flex align-center">
                        <v-icon color="slate" class="mr-2 sm:mr-3" size="24 sm:size-28"
                          >mdi-folder-zip-outline</v-icon
                        >
                        <div>
                          <span
                            class="text-lg sm:text-xl font-bold text-slate-700 onest-font"
                            >{{ cycle.nome_validacao }}</span
                          >
                          <div class="text-xs sm:text-sm text-slate-400 mt-1">
                            Situação:
                            <v-chip
                              size="x-small"
                              color="grey"
                              class="font-normal ml-1"
                              variant="tonal"
                            >
                              Finalizada
                            </v-chip>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex align-center gap-4 mt-2 mt-sm-0">
                        <span class="text-xs sm:text-sm text-slate-500 font-medium">
                          <v-icon
                            start
                            icon="mdi-calendar-check"
                            size="14 sm:size-16"
                            class="mr-1"
                          ></v-icon>
                          Encerrado em: {{ formatDate(cycle.data_final_etapa) }}
                        </span>
                      </div>
                    </div>
                  </template>
                </v-expansion-panel-title>

                <v-expansion-panel-text
                  class="bg-slate-50/50 pa-2 pa-sm-4 border-t border-slate-150"
                >
                  <div class="space-y-6">
                    <div
                      v-for="projeto in cycle.projetos"
                      :key="projeto.id_projeto"
                      class="mb-6"
                    >
                      <!-- Projeto Title -->
                      <div class="d-flex align-center justify-between mb-2">
                        <div class="d-flex align-center">
                          <span
                            class="bg-slate-100 text-slate-600 font-bold px-2 py-0.5 sm:px-3 sm:py-1 rounded-lg text-xs sm:text-sm mr-2 sm:mr-3"
                          >
                            {{ projeto.sigla }}
                          </span>
                          <h3 class="text-base sm:text-xl font-bold text-slate-700">
                            {{ projeto.nome }}
                          </h3>
                        </div>
                      </div>

                      <!-- Desktop View: table layout -->
                      <div class="hidden sm:block table-responsive">
                        <table
                          class="w-full border-separate border-spacing-y-2 onest-font"
                        >
                          <thead>
                            <tr class="text-slate-500 font-medium text-sm">
                              <th class="p-4 text-left">Papel / Ator</th>
                              <th class="p-4 text-left">Resultado Obtido</th>
                              <th class="p-4 text-left">Status</th>
                              <th class="p-4 text-center">Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="roteiro in projeto.roteiros"
                              :key="roteiro.id_roteiro"
                              class="hover:bg-blue-50/50 transition-colors bg-white shadow-sm rounded-xl"
                            >
                              <td
                                class="py-4 px-6 font-normal text-slate-600 rounded-l-xl"
                              >
                                {{ roteiro.nome_ator }}
                              </td>
                              <td
                                class="py-4 px-6 text-slate-600"
                                style="width: 40%"
                              >
                                <div class="d-flex align-center">
                                  <v-progress-linear
                                    v-model="roteiro.progressoPercent"
                                    color="grey"
                                    height="8"
                                    rounded
                                    class="mr-3 flex-grow-1"
                                    bg-color="slate-200"
                                  ></v-progress-linear>
                                  <span
                                    class="text-sm font-bold text-slate-500 whitespace-nowrap"
                                  >
                                    {{ roteiro.avaliadas }}/{{ roteiro.total }}
                                    Func.
                                  </span>
                                </div>
                              </td>
                              <td class="py-4 px-2">
                                <v-chip
                                  size="small"
                                  color="grey"
                                  class="font-normal"
                                  variant="tonal"
                                >
                                  FINALIZADA
                                </v-chip>
                              </td>
                              <td class="py-4 px-4 text-center rounded-r-xl">
                                <v-btn
                                  color="secondary"
                                  variant="outlined"
                                  size="small"
                                  class="text-center font-normal rounded-full"
                                  prepend-icon="mdi-eye"
                                  @click="
                                    irParaRoteiro(
                                      projeto.id_projeto,
                                      roteiro.id_roteiro,
                                    )
                                  "
                                >
                                  Visualizar Respostas
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <!-- Mobile View: cards list -->
                      <div class="block sm:hidden space-y-4">
                        <div
                          v-for="roteiro in projeto.roteiros"
                          :key="roteiro.id_roteiro"
                          class="bg-white border border-slate-200 rounded-xl p-4 shadow-sm"
                        >
                          <div class="flex justify-between items-start mb-3">
                            <div>
                              <div class="text-xs text-slate-400 font-bold uppercase">Papel</div>
                              <div class="text-base font-bold text-slate-700">{{ roteiro.nome_ator }}</div>
                            </div>
                            <v-chip
                              size="small"
                              color="grey"
                              class="font-normal"
                              variant="tonal"
                            >
                              FINALIZADA
                            </v-chip>
                          </div>
                          
                          <div class="mb-4">
                            <div class="flex justify-between text-xs text-slate-500 font-medium mb-1">
                              <span>Progresso</span>
                              <span>{{ roteiro.avaliadas }}/{{ roteiro.total }} Func.</span>
                            </div>
                            <v-progress-linear
                              v-model="roteiro.progressoPercent"
                              color="grey"
                              height="6"
                              rounded
                              bg-color="slate-200"
                            ></v-progress-linear>
                          </div>

                          <v-btn
                            color="secondary"
                            variant="outlined"
                            size="small"
                            class="w-full font-bold rounded-xl"
                            prepend-icon="mdi-eye"
                            @click="irParaRoteiro(projeto.id_projeto, roteiro.id_roteiro)"
                          >
                            Visualizar Respostas
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-window-item>
        </v-window>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
/* eslint-disable */
/**
 * @module WorkspaceConvidado
 * @description
 * Este componente é responsável por exibir as validações em que o usuário convidado deve realizar os testes.
 * Ele exibe as validações ativas e passadas.
 */
import SnackBar from '@/components/SnackBar.vue';
import axios from 'axios';

const apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  name: 'WorkspaceConvidado',
  components: {
    SnackBar,
  },
  data() {
    return {
      tab: 'active',
      userName: localStorage.getItem('usuario') || 'Testador Convidado',
      idUsuario: Number(localStorage.getItem('idUsuario')) || 1,
      loading: false,
      activePanels: [0],
      pastPanels: [],
      validacaoCycles: [],
    };
  },
  computed: {
    activeCycles() {
      return this.validacaoCycles
        .filter(
          (c) =>
            c.situacao_validacao === 'USUARIOS_TESTANDO' &&
            new Date(c.data_final_etapa) >= new Date(),
        )
        .map((c) => this.mapCycleProgress(c));
    },
    pastCycles() {
      return this.validacaoCycles
        .filter(
          (c) =>
            c.situacao_validacao !== 'USUARIOS_TESTANDO' ||
            new Date(c.data_final_etapa) < new Date(),
        )
        .map((c) => this.mapCycleProgress(c));
    },
  },
  created() {
    this.fetchWorkspace();
  },
  methods: {
    async fetchWorkspace() {
      this.loading = true;
      try {
        const response = await axios.get(`${apiUrl}/api/v1/usuario-externo/workspace`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        this.validacaoCycles = response.data;
      } catch (error) {
        console.error('Erro ao buscar workspace do backend, usando dados mockados:', error);
        this.validacaoCycles = [
          {
            id_validacao: 12,
            nome_validacao: 'POC 2026.1',
            situacao_validacao: 'USUARIOS_TESTANDO',
            data_final_etapa: '2026-07-15T00:00:00.000Z',
            projetos: [
              {
                id_projeto: 1,
                sigla: 'LGPD',
                nome: 'LGPDefender',
                roteiros: [
                  {
                    id_roteiro: 101,
                    nome_ator: 'Desenvolvedor',
                    total: 4,
                    status: 'EM_ANDAMENTO',
                  },
                ],
              },
            ],
          },
          {
            id_validacao: 8,
            nome_validacao: 'POC 2025.2',
            situacao_validacao: 'VALIDACAO_FINALIZADA',
            data_final_etapa: '2025-12-10T00:00:00.000Z',
            projetos: [
              {
                id_projeto: 1,
                sigla: 'SISGIP',
                nome: 'Sistema de Gestão Integrada de Projetos',
                roteiros: [
                  {
                    id_roteiro: 201,
                    nome_ator: 'Desenvolvedor',
                    total: 5,
                    status: 'CONCLUIDO',
                  },
                ],
              },
            ],
          },
        ];
      } finally {
        this.loading = false;
      }
    },
    formatDate(dateString) {
      if (!dateString) {
        return '-';
      }
      const date = new Date(dateString);

      return date.toLocaleDateString('pt-BR');
    },
    getStatusColor(status) {
      if (status === 'CONCLUIDO') {
        return 'success';
      }
      if (status === 'EM_ANDAMENTO') {
        return 'warning';
      }

      return 'grey';
    },
    formatStatusText(status) {
      if (status === 'CONCLUIDO') {
        return 'CONCLUÍDO';
      }
      if (status === 'EM_ANDAMENTO') {
        return 'EM ANDAMENTO';
      }

      return 'PENDENTE';
    },
    mapCycleProgress(cycle) {
      const projectsMapped = cycle.projetos.map((proj) => {
        const roteirosMapped = proj.roteiros.map((rot) => {
          let avaliadas = 0;
          for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (
              key &&
              key.startsWith(
                `feedback_user_${this.idUsuario}_roteiro_${rot.id_roteiro}_escopo_`,
              )
            ) {
              avaliadas++;
            }
          }

          let status = rot.status;
          if (avaliadas === rot.total) {
            status = 'CONCLUIDO';
          } else if (avaliadas > 0) {
            status = 'EM_ANDAMENTO';
          } else {
            status = 'PENDENTE';
          }

          const progressoPercent =
            rot.total > 0 ? (avaliadas / rot.total) * 100 : 0;

          return {
            ...rot,
            avaliadas,
            status,
            progressoPercent,
          };
        });

        return {
          ...proj,
          roteiros: roteirosMapped,
        };
      });

      return {
        ...cycle,
        projetos: projectsMapped,
      };
    },
    irParaRoteiro(idProjeto, idRoteiro) {
      this.$router.push(
        `/projects/${idProjeto}/roteiros/${idRoteiro}/executar`,
      );
    },
  },
};
</script>

<style scoped>
.onest-font {
  font-family: 'Onest', sans-serif !important;
}
.bg-slate-50 {
  background-color: #f8fafc !important;
}
.table-responsive {
  width: 100%;
  overflow-x: auto;
}
</style>
